const CALISTA_ADVISORY_SYSTEM_CONFIG_URL = `${process.env.REACT_APP_CIA_ORIGIN_URL}/cia-admin/system-config`

const CalistaAdvisorySystemConfigApiUrls = {
    GET: `${CALISTA_ADVISORY_SYSTEM_CONFIG_URL}/get`,
    PUT: `${CALISTA_ADVISORY_SYSTEM_CONFIG_URL}/update`
}

export default CalistaAdvisorySystemConfigApiUrls
